import { ReactComponent as ModeSwitcher } from '@Icons/additional/modeSwitcher.svg';
import './header-actions.css';

const DarkMode: React.FC = () => {
  const handleClick = (): void => {
    // document.documentElement.classList.toggle('dark-theme');
  };

  return (
    <div
      onClick={handleClick}
      className="header-action-component dark trojan-neumorphism-box trojan-neumorphism-box-shadow"
    >
      <ModeSwitcher />
    </div>
  );
};

export default DarkMode;
